export default __webpack_public_path__ + "static/media/overlaytelegram.7ba90bfc.png";